const step1 = (bank) => `Please download, print out and sign the form indicated below. `
const step2 =  'After printing and signing the form, scan and upload using the upload functionality or email it to Reckon at bankdata@reckon.com.'
const step3 =  'It may take up to 10 business days for the bank to activate the feed. As soon as this is done you will be able to link the feed to one of your bank accounts.'

export const bankInfo = {
    0: { bank: '', step1: '', step2: '', step3: '', form: '' },
    1: { bank: 'ANZ - AU',
        step1: 'To setup your bank feeds you’ll need to be logged in to ANZ Internet Banking.',
        step2: 'Then select Profile, and Manage bank feeds. If this is your first time setting up a bank feed, select Get started. Otherwise, select Activate a new bank feed.',
        step3: 'When asked for your Primary ID enter the id below, you do not need to enter a secondary id or email address.',
        form: undefined },
    2: { bank: 'STG', step1: step1('St George'), step2, step3, form: 'Form_StG.pdf' },
    4: { bank: 'CBA', step1: step1('CBA'), step2, step3, form: 'Form_CBA.pdf' },
    7: { bank: 'NAB', step1: step1('NAB'), step2, step3, form: 'Form_NAB.pdf' },
    11: { bank: 'Kiwibank', step1: step1('Kiwibank'), step2, step3, form: 'Form_Kiwibank.pdf' },
    12: { bank: 'Kiwibank-CreditCard', step1: step1('Kiwibank-CreditCard'), step2, step3, form: 'Form_Kiwibank.pdf' },
    14: { bank: 'NBS', step1: step1('NBS'), step2, step3, form: 'Form_NBS.pdf' },
    16: { bank: 'ASB', step1: step1('ASB'), step2, step3, form: 'Form_ASB.pdf' },
    17: { bank: 'Westpac AU',
        step1: `To access your bank feed you’ll need to log in to Westpac Live Internet Banking. Once logged in Navigate 
        to ‘Services & Preferences’ and select ‘Services’. Then under Account services select Bank feeds.
        Select an account and choose Reckon for the third-party service provider.
        Paste the ID below into the Reckon User ID or Login field and click Connect Feed.`,
        step2: 'Or',
        step3: `Download the authorisation form using the link below, then print, complete and scan the form. Then upload it to us using the upload option next to this feed. Your feed will be active within 2 - 3 days when using this option.`,
        form: 'Form_WBC_AU.pdf' },
    18: { bank: 'Bank of Melbourne', step1: step1('Bank of Melbourne'), step2, step3, form: 'Form_StG.pdf' },
    21: { bank: 'Bank Of SA', step1: step1('Bank Of SA'), step2, step3, form: 'Form_StG.pdf' },
    26: { bank: 'Westpac NZ', step1: step1('WBC'), step2, step3, form: 'Form_WBC_NZ.pdf' },
    28: { bank: 'ANZ - NZ', step1: step1('ANZ'), step2, step3, form: 'Form_ANZ_NZ.pdf' },
    29: { bank: 'BOQ', step1: step1('BOQ'), step2, step3, form: 'Form_BOQ.pdf' },
    33: { bank: 'TSB', step1: step1('TSB'), step2, step3, form: 'Form_TSB_NZ.pdf' },
    34: { bank: 'Bendigo', step1: step1('Bendigo'), step2, step3, form: 'Form_Bendigo Authority.pdf' },
    41: { bank: 'Heritage', step1: step1('Heritage'), step2, step3, form: 'Form_Heritage.pdf' },
    44: { bank: 'Bendigo - Credit Card', step1: step1('Bendigo - Credit Card'), step2, step3, form: 'Form_Bendigo Authority.pdf' },
    45: { bank: 'Rural Bank', step1: step1('Rural Bank'), step2, step3, form: 'Form_Bendigo Authority.pdf' },
    47: { bank: 'Farmlands', step1: step1('Farmlands'), step2, step3, form: 'Form_Farmlands.pdf' },
    48: { bank: 'ASB-CreditCard', step1: step1('ASB-CreditCard'), step2, step3, form: 'Form_ASB_Card.pdf' },
}

export const bankFeedTypeDetails = {
    OpenBanking: 'Open Banking securely and instantly connects to your bank via an accredited third party, without the need to share internet banking details. Once a connection is established, it can take up to 1 hour to see transactions.',
    Directfeed: 'Available for most major banks, direct feeds provide a secure connection directly between the bank and Reckon. Some banks require signed paperwork, and it can take up to 10 days to see your transactions.',
    Yodlee: 'Yodlee is a third party that provides an instant connection with your bank. You will have to login in with your internet banking details. Once a connection is established, it can take up to 1 hour to see transactions.',
}

export const popularBanks = {
    AU: {
        OpenBanking: ['ANZ', 'CBA', 'WBC'],
        Directfeed: [1, 4, 7, 17],
        Yodlee: [3952, 3857, 3885, 103952, 103885],
    },
    NZ: {
        OpenBanking: [],
        Directfeed: [26, 28, 40],
        Yodlee: [12287, 12252, 112287, 112252],
    }
}


// WEBPACK FOOTER //
// ./src/components/FeedManagment/BankFeedInfo.js